// src/analytics.js
import AuthService from '@/services/AuthService';

function getSessionId() {
  let sid = sessionStorage.getItem('sid');
  if (!sid) {
    const a = new Uint8Array(16);
    crypto.getRandomValues(a);
    sid = Array.from(a).map(b => b.toString(16).padStart(2, '0')).join('');
    sessionStorage.setItem('sid', sid);
  }
  return sid;
}

/**
 * Log an analytics event.
 * - Works for both authenticated and anonymous users.
 * - If you REALLY need auth for a specific event, pass { requireAuth: true }.
 */
export async function logEvent(evt, props = {}, elMeta = {}, opts = {}) {
  const { requireAuth = false } = opts;

  let isAuthed = false;
  try { isAuthed = await AuthService.isAuthenticated(); } catch { console.log("catch1");}

  if (requireAuth && !isAuthed) return;

  const token = localStorage.getItem('token') || '';
  const payload = {
    jwt: token || null,
    authed: !!isAuthed,
    event: evt,
    props,
    route_name: window?.__lastRouteName || null,
    path: location.pathname + location.search + location.hash,
    session_id: getSessionId(),
    element_tag: elMeta.tag || null,
    element_text: elMeta.text || null,
    ts: Date.now()
  };

  const url = '/api/etherscan/track_event.php';

  try {
    // IMPORTANT: beacons can’t send Authorization headers.
    // Use fetch (with header) when authed; beacon is fine for anon.
    if (!isAuthed && navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }

    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify(payload),
      keepalive: true
    });
  } catch (err) {
    console.debug('logEvent failed (non-blocking):', err);
  }
}
// Global delegation stays the same
let _clickTrackerInstalled = false;
export function installClickTracker() {
  if (_clickTrackerInstalled) return;
  _clickTrackerInstalled = true;

  document.addEventListener('click', (e) => {
    const target = e.target.closest?.('[data-track]');
    if (!target) return;

    if (target.__trkLock && Date.now() - target.__trkLock < 400) return;
    target.__trkLock = Date.now();

    const name = target.getAttribute('data-track');
    let props = {};
    const raw = target.getAttribute('data-track-props');
    if (raw) {
      try { props = JSON.parse(raw); }
      catch (err) {
        // eslint-disable-next-line no-console
        console.debug('Invalid data-track-props JSON:', raw, err);
      }
    }
    const elMeta = {
      tag: target.tagName,
      text: (target.getAttribute('aria-label') || target.textContent || '').trim().slice(0, 120)
    };
    
//  console.log("log event 2");
    logEvent(name, props, elMeta); // ← now fires even if anon
  }, true);
}


/*
And if you ever need manual logging (e.g., on programmatic actions), just:

import { logEvent } from '@/analytics';
await logEvent('email_update_attempt', { new_email: this.emailDraft });

*/